module.exports = __webpack_public_path__ + "img/us.a9474aff.svg";